<!--
Copyright 2025 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="mat-elevation-z8">
  <mat-toolbar class="background">
    <mat-toolbar-row>
      <p>Group Members</p>
    </mat-toolbar-row>
    <mat-toolbar-row>
      <mat-form-field class="w-50">
        <mat-label>Search</mat-label>
        <input matInput [(ngModel)]="filterString" (keyup)="applyFilter($event)" #input autocomplete="off" />
        @if (filterString) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
          <mat-icon class="mdi-24px" fontIcon="mdi-close-circle-outline"></mat-icon>
        </button>
        }
      </mat-form-field>
      <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" aria-label="Select page of members"></mat-paginator>
    </mat-toolbar-row>
  </mat-toolbar>
  <table mat-table matSort matSortActive="name" matSortDirection="asc" [dataSource]="dataSource" class="w-100">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let model">
        {{ model.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let model">
        <button mat-icon-button (click)="delete(model.membership.id)" style="outline: none;"
          title="Remove {{ model.name }}" [disabled]="!canEdit">
          <mat-icon class="mdi-24px center-self" fontIcon="mdi-minus-circle-outline"></mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">
        @if (input.value) {
        No data matching the filter "{{ input.value }}"
        } @else {
        This Group currently has no members
        }
      </td>
    </tr>
  </table>
</div>
